import React from 'react';

const ESPN = ({ tournament }) => {
    return (
        <div className="bg-whiteish" id="espn">
            <div className="w3-content w3-container d-flex flex-row" style={{ paddingTop: '2em', paddingBottom: '2em' }}>
                <div style={{ width: 150 }} className="align-self-center"><img alt="" className="w-100" src="/images/logos/espn.png" /></div>
                <div className="w-100 align-self-center">
                    <span className="black font-12">On the road to the Challenge Sports 3v3 Tour Nationals at the ESPN Wide World of Sports Complex at the Walt Disney World(c) Resort. {tournament.ESPNDates}</span></div>
            </div>
        </div>
    );
}

export default ESPN;



// WEBPACK FOOTER //
// ./src/components/tournaments/partials/espn.js